module.exports = __webpack_public_path__ + "img/eb-word-optimized.39af30a6.svg";